

export type ArchivedDataProcessingBehavior =
    "ExcludeArchived"
    | "IncludeArchived"
    | "ArchivedOnly";